import { render, staticRenderFns } from "./BusinessEntitiesDropDownList.vue?vue&type=template&id=135b5562"
import script from "./BusinessEntitiesDropDownList.vue?vue&type=script&lang=js"
export * from "./BusinessEntitiesDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports